// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2tEQ4","file":"styles_file__cWgxS"};